var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTabs2',{staticClass:"affiliate-tabs",attrs:{"items":_vm.$options.tabs,"value":_vm.tab || _vm.$route.name},on:{"input":function($event){return _vm.$router.push({ name: $event })}}})}
var staticRenderFns = []

export { render, staticRenderFns }